import { themeHelpers } from '@gotamedia/fluffy';
import styled, { css } from 'styled-components';
const Footer = styled.div.withConfig({
  displayName: "style__Footer",
  componentId: "sc-1kr703j-0"
})(["display:flex;padding:40px 64px;flex-direction:column;align-items:center;gap:40px;background:#2E2A25;width:100%;margin-top:auto;", " @media screen and (max-width:1300px){flex-direction:column;padding:32px 16px;align-items:flex-start;}"], themeHelpers.isNotLargeDevice(css(["flex-direction:column;padding:32px 16px;align-items:flex-start;"])));
const LogoWrapper = styled.div.withConfig({
  displayName: "style__LogoWrapper",
  componentId: "sc-1kr703j-1"
})(["width:200px;display:block;"]);
const FooterColumnWrapper = styled.div.withConfig({
  displayName: "style__FooterColumnWrapper",
  componentId: "sc-1kr703j-2"
})(["display:flex;align-items:flex-start;gap:147px;max-width:1600px;", " ", " @media screen and (max-width:1300px){max-width:744px;flex-direction:column;gap:48px;}"], themeHelpers.isMediumDevice(css(["max-width:744px;flex-direction:column;gap:48px;"])), themeHelpers.isSmallDevice(css(["gap:48px;max-width:375px;flex-direction:column;"])));
const Flex = styled.span.withConfig({
  displayName: "style__Flex",
  componentId: "sc-1kr703j-3"
})(["max-width:1600px;width:100%;"]);
const FlexColumn = styled.div.withConfig({
  displayName: "style__FlexColumn",
  componentId: "sc-1kr703j-4"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:24px;flex:1 1 0;@media screen and (max-width:1300px){width:100%;}", " ", ""], themeHelpers.isMediumDevice(css(["width:100%;"])), themeHelpers.isSmallDevice(css(["flex-direction:column;padding-bottom:0;"])));
const FlexRow = styled.div.withConfig({
  displayName: "style__FlexRow",
  componentId: "sc-1kr703j-5"
})(["display:block;", " ", ""], themeHelpers.isSmallDevice(css(["flex-direction:column;"])), themeHelpers.isMediumDevice(css(["flex-direction:column;"])));
const Section = styled.div.withConfig({
  displayName: "style__Section",
  componentId: "sc-1kr703j-6"
})(["display:flex;flex-direction:column;", ""], themeHelpers.isMediumDevice(css(["width:100%;"])));
const BoldText = styled.p.withConfig({
  displayName: "style__BoldText",
  componentId: "sc-1kr703j-7"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:700;line-height:20px;margin-right:2px;display:inline;color:#DADAD8;"]);
const Text = styled.p.withConfig({
  displayName: "style__Text",
  componentId: "sc-1kr703j-8"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:400;line-height:20px;display:inline;color:", ";"], ({
  theme
}) => theme.colors.grey[3]);
const Headline = styled.h2.withConfig({
  displayName: "style__Headline",
  componentId: "sc-1kr703j-9"
})(["font-family:'Sanomat Sans Text';font-weight:700;font-size:14px;line-height:18px;white-space:pre-line;margin-right:2px;color:", ";"], ({
  theme
}) => theme.colors.grey[4]);
const SocialMediaWrapper = styled.div.withConfig({
  displayName: "style__SocialMediaWrapper",
  componentId: "sc-1kr703j-10"
})(["display:flex;flex:1 1 0;gap:32px;margin-top:10px;"]);
const AppsWrapper = styled.div.withConfig({
  displayName: "style__AppsWrapper",
  componentId: "sc-1kr703j-11"
})([""]);
const SocialMediaLink = styled.a.withConfig({
  displayName: "style__SocialMediaLink",
  componentId: "sc-1kr703j-12"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:400;line-height:20px;text-decoration:none;color:#B3B2B1;display:flex;flex-direction:column;align-items:center;gap:8px;&:hover{text-decoration:underline;}"]);
const Link = styled.a.withConfig({
  displayName: "style__Link",
  componentId: "sc-1kr703j-13"
})(["font-family:Sanomat Sans Text;font-size:15px;font-style:normal;font-weight:400;line-height:20px;text-decoration:none;color:#B3B2B1;&:hover{text-decoration:underline;}"]);
const Links = styled.div.withConfig({
  displayName: "style__Links",
  componentId: "sc-1kr703j-14"
})([""]);
const IconWrapper = styled.div.withConfig({
  displayName: "style__IconWrapper",
  componentId: "sc-1kr703j-15"
})([""]);
const SocialMediaIcon = styled.img.withConfig({
  displayName: "style__SocialMediaIcon",
  componentId: "sc-1kr703j-16"
})(["min-width:40px;min-height:40px;"]);
export { Footer, FooterColumnWrapper, Flex, FlexColumn, FlexRow, Section, Text, BoldText, Headline, SocialMediaWrapper, SocialMediaLink, AppsWrapper, IconWrapper, SocialMediaIcon, Link, Links, LogoWrapper };